export const SIGN_UP_CHAMPION_REQUEST = 'SIGN_UP_CHAMPION_REQUEST';
export const SIGN_UP_CHAMPION_SUCCESS = 'SIGN_UP_CHAMPION_SUCCESS';
export const SIGN_UP_CHAMPION_FAILURE = 'SIGN_UP_CHAMPION_FAILURE';

export const LOG_IN_CHAMPION_REQUEST = 'LOG_IN_CHAMPION_REQUEST';
export const LOG_IN_CHAMPION_SUCCESS = 'LOG_IN_CHAMPION_SUCCESS';
export const LOG_IN_CHAMPION_FAILURE = 'LOG_IN_CHAMPION_FAILURE';

export const GET_CHAMPION_DATA_REQUEST = 'GET_CHAMPION_DATA_REQUEST';
export const GET_CHAMPION_DATA_SUCCESS = 'GET_CHAMPION_DATA_SUCCESS';
export const GET_CHAMPION_DATA_FAILURE = 'GET_CHAMPION_DATA_FAILURE';

export const GET_POOL_LIST_REQUEST = 'GET_POOL_LIST_REQUEST';
export const GET_POOL_LIST_SUCCESS = 'GET_POOL_LIST_SUCCESS';
export const GET_POOL_LIST_FAILURE = 'GET_POOL_LIST_FAILURE';

export const SUBMIT_CHAMPION_SOCIAL_FORM_REQUEST = 'SUBMIT_CHAMPION_SOCIAL_FORM_REQUEST';
export const SUBMIT_CHAMPION_SOCIAL_FORM_SUCCESS = 'SUBMIT_CHAMPION_SOCIAL_FORM_SUCCESS';
export const SUBMIT_CHAMPION_SOCIAL_FORM_FAILURE = 'SUBMIT_CHAMPION_SOCIAL_FORM_FAILURE';
export const CLEAR_CHAMPION_SOCIAL_FORM = 'CLEAR_CHAMPION_SOCIAL_FORM';

export const GET_CHAMPION_PROFILE_DATA_REQUEST = 'GET_CHAMPION_PROFILE_DATA_REQUEST';
export const GET_CHAMPION_PROFILE_DATA_SUCCESS = 'GET_CHAMPION_PROFILE_DATA_SUCCESS';
export const GET_CHAMPION_PROFILE_DATA_FAILURE = 'GET_CHAMPION_PROFILE_DATA_FAILURE';

export const GET_CHAMPION_PROFILE_POOLS_REQUEST = 'GET_CHAMPION_PROFILE_POOLS_REQUEST';
export const GET_CHAMPION_PROFILE_POOLS_SUCCESS = 'GET_CHAMPION_PROFILE_POOLS_SUCCESS';
export const GET_CHAMPION_PROFILE_POOLS_FAILURE = 'GET_CHAMPION_PROFILE_POOLS_FAILURE';

export const GET_CHAMPION_POOL_TILES_REQUEST = 'GET_CHAMPION_POOL_TILES_REQUEST';
export const GET_CHAMPION_POOL_TILES_SUCCESS = 'GET_CHAMPION_POOL_TILES_SUCCESS';
export const GET_CHAMPION_POOL_TILES_FAILURE = 'GET_CHAMPION_POOL_TILES_FAILURE';

export const SUBMIT_CHAMPION_STAKE_FORM_REQUEST = 'SUBMIT_CHAMPION_STAKE_FORM_REQUEST';
export const SUBMIT_CHAMPION_STAKE_FORM_SUCCESS = 'SUBMIT_CHAMPION_STAKE_FORM_SUCCESS';
export const SUBMIT_CHAMPION_STAKE_FORM_FAILURE = 'SUBMIT_CHAMPION_STAKE_FORM_FAILURE';
export const CLEAR_CHAMPION_STAKE_FORM = 'CLEAR_CHAMPION_STAKE_FORM';

export const LOG_OUT_CHAMPION = 'LOG_OUT_CHAMPION';

export const SET_CHAMPION_HAS_OWN_POOL = 'SET_CHAMPION_HAS_OWN_POOL';
